<template>
  <div>
    <div class="menuFram mt-3 ml-5">
      <div class="container"></div>

      <p>請按此登出展昭會員</p>
      <button type="submit" class="btn btn-primary" @click.prevent="logout">會員登出</button>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        access_token: '',
      }
    },

    methods: {
      logout() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin/v1/Logout'

        vm.$http.get(url).then(function (response) {
          // console.log('已成功登出')
          alert('已成功登出')
        })

        document.location.href = 'https://www.chanchao.com.tw/accounts/login'
      },
    },

    created() {
      const vm = this

      //get isAuthenticated from cookie
      // vm.access_token = vm.getCookie('as')

      //GET LANDING PAGE

      // vm.lastUrl = localStorage.getItem('url')
      // // console.log(vm.lastUrl)

      //更換英文語系
      vm.$i18n.locale = 'zhTW'
    },
  }
</script>

<style lang="scss" scoped>
  //Swal setting

  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 12px;
  }

  #main-footer {
    bottom: 0;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navHead {
    font-size: 29px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 17px;
  }

  .navLogo {
    height: 55px;
  }

  @media (max-width: 768px) {
    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
      padding-top: 30px;
    }

    .navEnText {
      display: none;
    }

    .navHead {
      font-size: 23px;
      color: #2c3e50;
    }

    .navCnt {
      font-size: 14px;
    }

    .navLogo {
      height: 50px;
      width: 100px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  input::-webkit-input-placeholder {
    /* placeholder*/
    color: #aab2bd;
    font-size: 14px;
  }

  .linkFrame {
    font-size: 15px;
  }

  .linkText {
    position: relative;
  }

  .linkLine {
    position: absolute;
    height: 13px;
    //width: 33px;
    top: 20%;
    left: 0;
    border-left: 2px solid #a1a7a8;
  }
</style>
